import { SearchItem } from './searchTypes'

// ORG-06: keep circles only in the meeting circle picker, but never hide the
// value already selected (e.g. a meeting already set on a leaf role). `keepId`
// is the current form value: an item matching it is kept even if it's a role.
export function filterCirclesOnly(
  items: SearchItem[],
  keepId?: string
): SearchItem[] {
  return items.filter((item) => item.isCircle || item.id === keepId)
}
